import { createContext } from "react";

export const defaultContextValue = {
  selectedProduct: undefined as string | undefined,
  showSideModal: false,
  showCancelReportModal: false,
  isEditConfig: false,
  isActive: false,
  forceEnableField: false,
  isErrorMessageVisible: false,
  clickFrom: 'auto_report_page',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onShowSideModal: (product_name: string, isFromProduct: boolean) => {},
  onCloseSideModal: () => {},
  onDisable: () => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onShowDisableReportModal: (product_name: string) => {},
  onCloseDisableReportModal: (isFromModal?: boolean) => {},
  setIsActive: (value: boolean) => {},
  setIsErrorMessageVisible: (value: boolean) => {},
  onToggleActivation: () => {},
  onShowDisableReportModalFromProduct: () => {},
};

export const AutoReportContext = createContext(defaultContextValue);
